<template>
  <div class="padded">

    <h2><i class="fa fa-tachometer-alt">&nbsp;</i><org-badge /> Dashboard
      <small v-if="org().shortName" class="text-info pull-right hidden-sm-and-down">{{org().name}}</small>

        <el-badge v-if="isSuper() && alerts > 0" :value="alerts">
          <el-button type="primary" @click="alertDrawer = true" style="margin-bottom: 1em;">New Users</el-button>
        </el-badge>
     </h2>

    <el-drawer
      title="New Users"
      :visible.sync="alertDrawer"
      direction="rtl"
      :size="isDesktop ? '52.8%' : '74.1%'">

      <good-table
        :cols="cols"
        :rows="rows"

        compact

        theme="polar-bear"
        />

    </el-drawer>



    <el-menu
      default-active="1"
      mode="horizontal"
      :unique-opened="true"
      @select="onClick">

      <el-submenu
          v-for="(item, index) in contents"
          v-if="item.visible"
          :key="item.key"
          :index="'' + index">
            <template #title>
              <i :class="item.icon ? 'text-warning fa fa-' + item.icon : ''"></i>
              <b v-if="isDesktop">{{item.title}}</b>
            </template>

            <el-menu-item
                v-for="(sub, ind2) of item.children"
                v-if="sub.visible"
                :index="sub.key"
                :disabled="sub.disabled"
                :key="sub.key">

              <i :class="sub.icon ? 'text-muted fa fa-' + sub.icon : ''"></i>
              <span>{{sub.title}}</span>

            </el-menu-item>
      </el-submenu>

  </el-menu>

  <el-row>
    <el-col :span="24">
      <div class="padded">
        <component :is="comp" />
      </div>
    </el-col>
  </el-row>


  </div>
</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import PostMixins from '@/mixins/PostMixins'

// import ReportFilter from '@/components/dashboard/ReportFilter'

import WaysReport from '@/components/dashboard/sharers/WaysReport'
import SharingSummaryReport from '@/components/dashboard/sharers/SharingSummaryReport'

import BackhaulDashboard from '@/components/dashboard/backhaul/BackhaulDashboard'

// Property
import PropertySummary from '@/components/dashboard/views/PropertySummary'
import PropertyLandlords from '@/components/dashboard/property/PropertyLandlords'
import PropertyExpiry from '@/components/dashboard/property/PropertyExpiry'
import TenancyDue from '@/components/dashboard/property/TenancyDue'
import PropertyRentalMonth from '@/components/dashboard/property/PropertyRentalMonth'
import PropertyRentalSummary from '@/components/dashboard/property/PropertyRentalSummary'
import SitesWithoutLandlords from '@/components/dashboard/property/SitesWithoutLandlords'


import GeneralSummary from '@/components/dashboard/views/GeneralSummary'
import ProjectSummary from '@/components/dashboard/views/ProjectSummary'

// Requests
import RequestsReport from '@/components/dashboard/requests/RequestsReport'
import SummaryRequests from '@/components/dashboard/requests/SummaryRequests'


// Sites
import SiteGroupReport from '@/components/dashboard/sites/SiteGroupReport'
import TowerSuppliersReport from '@/components/dashboard/sites/TowerSuppliersReport'
import StructureReport from '@/components/dashboard/sites/StructureReport'

// Finance
import FinanceSummary from '@/components/dashboard/views/FinanceSummary'

import UtilityReport from '@/components/dashboard/finance/UtilityReport'
import RevenueReport from '@/components/dashboard/finance/RevenueReport'

import InvoicingView from '@/components/finance/InvoicingView'

import ProgressReport from '@/components/dashboard/progress/ProgressReport'
import PermitsDueReport from '@/components/dashboard/permits/PermitsDueReport'
import FilesActivityTable from '@/components/tables/FilesActivityTable'

import WorkflowReport from '@/components/dashboard/workflow/WorkflowReport'
// import WorkflowGantt from '@/components/dashboard/workflow/WorkflowGantt'

import RollOutReport from '@/components/dashboard/sites/RollOutReport'

import SummaryDashboard from '@/components/dashboard/views/SummaryDashboard'

import MaintenanceSummary from '@/components/dashboard/views/MaintenanceSummary'
import MaintenanceView from '@/components/maintenance/MaintenanceView'

import SiteWorkflow from '@/components/workflow/site/SiteWorkflow'

import EquipView from '@/components/assets/EquipView'

export default {
  mixins: [ArrayMixins, DateMixins, PostMixins],

  methods: {


    onClick (item, path, data) {
      let n = path[0]
      let obj = this.find('key', item, this.contents[n], 'children')

      if (obj) {
        this.comp = obj.comp
      }

    },

    getNewUsers(data) {
      this.rows = data
      this.alerts = this.rows.length
    },

    format (date) {
      return this.formatDate(date)
    },

  },

  data () {
    return {

      alerts: 0,
      alertDrawer: false,

      comp: SummaryDashboard,

      cols: [
        {
        field: 'id',
        hidden: true
        },
        {
        label: 'Name',
        field: 'name'
        },
        {
        label: 'Category',
        field: 'orgCategory',
        tdClass: 'hidden-md-and-down',
        thClass: 'hidden-md-and-down',
        },
        {
        field: 'organisation_id',
        hidden: true
        },
        {
        label: 'Org.',
        field: 'orgName',
        tdClass: 'hidden-sm-and-down',
        thClass: 'hidden-sm-and-down',
        },
        {
        label: 'Created',
        field: 'created_at',
        type: 'date',
        formatFn: this.format
        },
      ],

      rows: [],

      contents: [
        {key: '0-summary',
          title: 'Management',
          icon: 'globe',
          comp: null,
          visible: this.isManager(),
          children: [
            {key: '1-summary', title: 'Summary', icon: 'globe', comp: SummaryDashboard, visible: true},
            {key: '2-fin-sum', title: 'Finance', icon: 'money-bill-alt', comp: FinanceSummary, visible: this.canAccess('finance|management')},
            {key: '3-backhaul', title: 'Backhaul', icon: 'wifi', comp: BackhaulDashboard, visible: this.canAccess('project|maintenance|management')},
            {key: '4-requests-sharer', title: 'Sharer Requests', icon: 'share-alt', comp: SummaryRequests, visible: this.canAccess('project|maintenance|management')},
            {key: '5-workflow-report', title: 'Workflow Report', icon: 'tachometer-alt', comp: WorkflowReport, visible: this.canAccess('project|maintenance|management')}
          ]
        },
        {key: '0-sites',
          title: 'Sites',
          icon: 'broadcast-tower',
          comp: null,
          visible: this.isTowerCo() && this.canAccess('project|maintenance|management'),
          children: [
            {key: '1-sites-summary', title: 'Summary', icon: 'globe', comp: ProjectSummary, visible: this.canAccess('project|maintenance|management')},
            {key: '1-sites-roll', title: 'Roll Out', icon: 'chart-line', comp: RollOutReport, visible: this.canAccess('project|maintenance|management')},
            {key: '1-sites-ways', title: 'Ways', icon: 'sort-numeric-up', comp: WaysReport, visible: this.canAccess('project|management')},
            {key: '1-sites-sharing-summary', title: 'Sharing Summary', icon: 'users', comp: SharingSummaryReport, visible: this.canAccess('project|management')},
            {key: '1-sites-site-groups', title: 'Site Groups', icon: 'th-large', comp: SiteGroupReport, visible: this.canAccess('project|maintenance|finance|management')},
            {key: '1-sites-tower-suppliers', title: 'Tower Suppliers', icon: 'tower-cell', comp: TowerSuppliersReport, visible: this.canAccess('project|maintenance|finance|management')},
            {key: '1-sites-separator-1', title: '', icon: 'minus', comp: null, visible: true, disabled: true},
            {key: '1-sites-requests', title: 'Requests', icon: 'share-alt', comp: RequestsReport, visible: this.canAccess('project|maintenance|management')},
            {key: '1-sites-struct', title: 'Structures', icon: 'sitemap', comp: StructureReport, visible: this.canAccess('project|maintenance|management')}
          ]
        },
        {key: '0-maint',
          title: 'Maintenance',
          icon: 'tools',
          comp: null,
          visible: this.isTowerCo() && this.canAccess('maintenance|project|management'),

          children: [
            {key: '1-maint-summary', title: 'Summary', icon: 'globe', comp: MaintenanceSummary, visible: this.canAccess('project|maintenance|management')},
            {key: '2-maint-tickets', title: 'Tickets', icon: 'headset', comp: MaintenanceView, visible: this.canAccess('project|maintenance|management')},
            {key: '3-maint-workflow', title: 'Site Workflows', icon: 'list-ol', comp: SiteWorkflow, visible: this.canAccess('projects|maintenance')},
/*            {key: '4-maint-gantt', title: 'Workflow Gantt', icon: 'stream', comp: WorkflowGantt, visible: this.canAccess('projects|maintenance')}, */
            {key: '5-maint-equip', title: 'Site Equipment', icon: 'tools', comp: EquipView, visible: this.canAccess('maintenance|project|management')}
          ]
        },
        {key: '0-prop',
          title: 'Property',
          icon: 'home',
          comp: null,
          visible: this.isTowerCo() && this.canAccess('property|management'),
          children: [
            {key: '1-prop-summary', title: 'Summary', icon: 'globe', comp: PropertySummary, visible: this.canAccess('property|management')},
            {key: '1-prop-expiry', title: 'Expiry', icon: 'calendar-day', comp: PropertyExpiry, visible: this.canAccess('property|management')},
            {key: '1-prop-due', title: 'Tenancy Due', icon: 'asterisk', comp: TenancyDue, visible: this.canAccess('property|management')},
            {key: '1-prop-rental-summary', title: 'Rentals Summary', icon: 'hand-holding-usd', comp: PropertyRentalSummary, visible: this.canAccess('property|management')},
            {key: '1-prop-month', title: 'Rental by Month', icon: 'calendar', comp: PropertyRentalMonth, visible: this.canAccess('property|management')},
            {key: '1-prop-land', title: 'Landlords', icon: 'house', comp: PropertyLandlords, visible: this.canAccess('property|management')},
            {key: '1-prop-without-land', title: 'Sites Without Landlords', icon: 'user-slash', comp: SitesWithoutLandlords, visible: this.canAccess('property|management')}
          ]
        },
        {key: '0-fin',
          title: 'Finance',
          icon: 'money-bill-alt',
          comp: null,
          visible: this.isTowerCo() && this.canAccess('finance|management'),
          children: [
            {key: '1-fin-sum', title: 'Summary', icon: 'globe', comp: FinanceSummary, visible: this.canAccess('finance|management')},
            {key: '1-fin-fees', title: 'New Revenue', icon: 'dollar-sign', comp: RevenueReport, visible: this.canAccess('finance|management')},
            {key: '1-fin-util', title: 'Utility', icon: 'plug', comp: UtilityReport, visible: this.canAccess('finance|admin')},
            {key: '1-fin-inv', title: 'Invoices', icon: 'money-bill-alt', comp: InvoicingView, visible: this.canAccess('finance|management')},
            {key: '1-fin-due', title: 'Tenancy Due', icon: 'asterisk', comp: TenancyDue, visible: this.canAccess('finance|management')}
          ]
        },
        {key: '0-ops',
          title: 'Operations',
          icon: 'cog',
          comp: null,
          visible: this.isTowerCo() && this.canAccess('project|maintenance|admin|management'),
          children: [
            {key: '1-ops-summary', title: 'Summary', icon: 'globe', comp: GeneralSummary, visible: this.canAccess('project|maintenance|admin|management')},
            {key: '1-ops-permits', title: 'Progress', icon: 'file', comp: ProgressReport, visible: this.canAccess('admin|management|project')},
            {key: '2-ops-permits-due', title: 'Permits Due', icon: 'list', comp: PermitsDueReport, visible: this.canAccess('admin|maintenance|management')},
            {key: '3-ops-files', title: 'Recent Files', icon: 'folder-tree', comp: FilesActivityTable, visible: this.canAccess('admin|maintenance|management')}
          ]
        }
      ]
    }

  },

  created () {

    this.getStats (this.org().id, true)

    if (this.isSuper()) {
      this.fetchData('/report/system/users/false', this.getNewUsers)
    }

  }

}
</script>
